import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MessengerService } from './services/messenger/messenger.service';
import { NavigationItemService } from './services/navigation-item/navigation-item.service';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { IntervalService } from './services/interval/interval.service';
import { LocalStorageService } from './services/local-storage/local-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  providers: [LocalStorageService]
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild('mainApp') mainApp;

  ready = false;
  serverError = false;
  subscriptions = [];
  isPreview = false;

  status: OnlineStatusType = null;

  showPreviewMsg = false;

  constructor(
    private messenger: MessengerService, private navigationItemService: NavigationItemService,
    private onlineStatusService: OnlineStatusService
  ) {
    this.status = this.onlineStatusService.getStatus();

    this.subscriptions.push(this.messenger.$languageReady.subscribe(done => {
      if (done) {
        this.initializeApp();
      }
    }));
    this.subscriptions.push(this.messenger.$serverError.subscribe(err => {
      this.serverError = err;
    }));

    if (window['preview']) {
      this.isPreview = true;
      this.startPreviewInterval();
    }
  }

  public ngOnInit() {
    registerLocaleData(localeDe, 'de');
  }

  ngOnDestroy() {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions.length = 0;
  }

  startPreviewInterval() {
    this.showPreviewMsg = false;
    IntervalService.set('previewMode', () => {
      this.showPreviewMsg = true;
    }, 300000);
  }

  public initializeApp() {
    this.ready = true;
    this.subscriptions.push(this.messenger.$mainPackage.subscribe(json => {
      if (json && json.menuItems && json.menuItems) {
        this.navigationItemService.initMenu(json.menuItems, true).then(() => {});
      }
    }));
  }
}
